import { Observable } from 'rxjs';

import {
  QueryInput,
  RenderingContext,
  RenderingContextQueryResult,
  SitePagesQueryResult,
  WchSdkSearch,
} from './../../../../../api';
import { queryToString } from './../../../../../utils';
import { WchService } from './../../../wch.service';

export interface SdkSearchDependencies {

  wchService: WchService;
}

export class SdkSearch implements WchSdkSearch {

  // the API
  getRenderingContextById: (aId: string, aLevels?: number) => Observable<RenderingContext>;
  getRenderingContexts: (aValue: QueryInput, aLevels?: number) => Observable<RenderingContextQueryResult>;
  getSitePages: (aValue: QueryInput) => Observable<SitePagesQueryResult>;

  constructor(aDeps: SdkSearchDependencies) {

    // the service and callbacks
    const that = this;
    const wchService = aDeps.wchService;

    // update the callbacks
    that.getRenderingContextById = (aId, aLevels) => wchService.getRenderingContextById(aId, aLevels);
    that.getRenderingContexts = (aValue, aLevels) => wchService.getRenderingContextsByQuery(queryToString(aValue), aLevels);
    that.getSitePages = (aValue: QueryInput) => wchService.getSitePagesByQuery(queryToString(aValue));
  }
}
